import {
  ExclamationTriangleIcon,
  InformationCircleIcon,
  CheckCircleIcon,
  XCircleIcon,
  FlagIcon, MinusCircleIcon,
} from "@heroicons/react/24/outline";

const types = {
  neutral: {
    Icon: MinusCircleIcon,
    classes: {
      light: "bg-gray-100",
      regular: "bg-gray-100",
      textRegular: "text-gray-500",
      textExtraBold: "text-gray-800",
      textSemibold: "text-gray-600",
      textBold: "text-gray-500",
      hoverLight: "hover:bg-gray-100",
      focusOffset: "focus:ring-offset-gray-50",
      focus: "focus:ring-gray-600",
    },
  },
  neutralAlt: {
    Icon: MinusCircleIcon,
    classes: {
      light: "bg-ivory",
      regular: "bg-ivory",
      textRegular: "text-ivory-500",
      textExtraBold: "text-ivory-800",
      textSemibold: "text-ivory-600",
      textBold: "text-ivory-500",
      hoverLight: "hover:bg-ivory-100",
      focusOffset: "focus:ring-offset-gray-50",
      focus: "focus:ring-gray-600",
    },
  },
  success: {
    Icon: CheckCircleIcon,
    classes: {
      light: "bg-green-50",
      regular: "bg-green-100",
      textRegular: "text-green-400",
      textExtraBold: "text-green-800",
      textSemibold: "text-green-600",
      textBold: "text-green-700",
      hoverLight: "hover:bg-green-100",
      focusOffset: "focus:ring-offset-green-50",
      focus: "focus:ring-green-600",
    },
  },
  error: {
    Icon: XCircleIcon,
    classes: {
      light: "bg-red-50",
      regular: "bg-red-100",
      textRegular: "text-red-400",
      textExtraBold: "text-red-800",
      textSemibold: "text-red-600",
      textBold: "text-red-700",
      hoverLight: "hover:bg-red-100",
      focusOffset: "focus:ring-offset-red-50",
      focus: "focus:ring-red-600",
    },
  },
  warning: {
    Icon: ExclamationTriangleIcon,
    classes: {
      light: "bg-yellow-50",
      regular: "bg-yellow-100",
      textRegular: "text-yellow-400",
      textExtraBold: "text-yellow-800",
      textSemibold: "text-yellow-600",
      textBold: "text-yellow-700",
      hoverLight: "hover:bg-yellow-100",
      focusOffset: "focus:ring-offset-yellow-50",
      focus: "focus:ring-yellow-600",
    },
  },
  info: {
    Icon: InformationCircleIcon,
    classes: {
      light: "bg-blue-50",
      regular: "bg-blue-100",
      textRegular: "text-blue-400",
      textExtraBold: "text-blue-800",
      textSemibold: "text-blue-600",
      textBold: "text-blue-700",
      hoverLight: "hover:bg-blue-100",
      focusOffset: "focus:ring-offset-blue-50",
      focus: "focus:ring-blue-600",
    },
  },
  primary: {
    Icon: FlagIcon,
    classes: {
      light: "bg-purple-100",
      regular: "bg-purple-200",
      textRegular: "text-purple-500",
      textExtraBold: "text-purple-900",
      textSemibold: "text-purple-700",
      textBold: "text-purple-800",
      borderLight: "border-purple-300",
      hoverLight: "hover:bg-purple-200",
      focusOffset: "focus:ring-offset-purple-100",
      focus: "focus:ring-purple-700",
    },
  },
  image: {
    Icon: null,
    classes: {},
  },
  tcs: {
    Icon: ExclamationTriangleIcon,
    classes: {
      light: "bg-yellow-50",
      regular: "bg-yellow-100",
      textRegular: "text-yellow-400",
      textExtraBold: "text-yellow-800",
      textSemibold: "text-yellow-600",
      textBold: "text-yellow-700",
      hoverLight: "hover:bg-yellow-100",
      focusOffset: "focus:ring-offset-yellow-50",
      focus: "focus:ring-yellow-600",
    },
  },
};

export default types;
